<script setup>
import { ErrorMessage } from 'vee-validate';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
});

const model = defineModel();
</script>

<template>
  <div class="mt-6">
    <label
      :for="props.id"
      class="flex items-center space-x-2 cursor-pointer"
    >
      <input
        v-bind="$attrs"
        :id="props.id"
        v-model="model"
        type="checkbox"
        :required="props.isRequired"
        class="absolute opacity-0 w-5 h-5 z-10"
      >
      <div
        class="w-5 h-5 flex items-center justify-center border border-gray-300 rounded peer-focus:ring-1 peer-focus:ring-highlight"
        :class="{'bg-secondary': model}"
      >
        <svg
          v-if="model"
          class="w-4 h-4 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span
        v-html="props.label"
        class="text-sm font-medium text-primary"
      />
    </label>
    <ErrorMessage
      :name="props.id"
      class="mt-2 text-sm text-red-400"
      as="p"
    />
  </div>
</template>
